var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoingSwimming(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 257,
    viewBox: "0 0 176 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.108 102.77C173.724 122.365 148.048 139.311 147.374 159.981C146.703 180.556 174.676 200.89 163.348 218.075C152.342 234.773 124.367 218.622 105.126 224.075C86.1397 229.455 72.7569 251.744 53.1735 249.297C33.021 246.778 12.9989 231.232 7.03349 211.816C1.18403 192.777 18.865 175.317 24.5832 156.241C28.4053 143.49 29.6527 130.9 34.9495 118.689C42.1512 102.086 45.268 81.6377 60.8985 72.5191C77.5299 62.8166 98.7025 65.4161 117.224 70.6914C136.712 76.2423 160.624 83.5695 167.108 102.77Z",
    fill: "#DEFBFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 91.5,
    cy: 211,
    rx: 48.5,
    ry: 5,
    fill: "#93CFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.954 210.682H78.7136L85.0553 127.329H113.869V201.617V202.228L114.312 202.649L114.312 202.649L114.313 202.65L114.316 202.653L114.331 202.667L114.389 202.723C114.441 202.772 114.518 202.846 114.617 202.941C114.815 203.132 115.101 203.41 115.453 203.755C116.155 204.445 117.115 205.402 118.146 206.472C119.459 207.835 120.842 209.335 121.954 210.682Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.646 210.682C101.415 210.323 101.097 209.935 100.682 209.519C99.6711 208.508 98.2772 207.533 96.8142 206.669C95.3627 205.812 93.9022 205.1 92.7992 204.599C92.2493 204.35 91.7921 204.155 91.4743 204.024C91.3154 203.958 91.1916 203.908 91.1087 203.875C91.0929 203.868 91.0785 203.863 91.0656 203.858C91.045 203.849 91.0283 203.843 91.0158 203.838L90.9938 203.829L90.9892 203.828L90.9888 203.828L90.9885 203.827L90.9885 203.827L89.7857 203.364L90.1287 202.122L105.974 144.715H65.1021L62.0716 210.682H101.646Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6951 127.961H114.326V154.609L101.762 159.543L64.6951 152.284V127.961Z",
    fill: "#003792",
    stroke: "#003792",
    strokeWidth: 1.58061
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3875 82.1288L89.3899 81.9657L87.9964 81.9171C84.5661 81.7976 81.8468 78.9531 81.8979 75.505C81.9496 72.0136 84.8219 69.2252 88.3133 69.2769C88.3764 69.2778 88.4393 69.2797 88.5019 69.2824L88.5325 69.2838L88.5632 69.2838C88.7193 69.284 88.8757 69.2852 89.0323 69.2875C107.314 69.5584 121.915 84.5984 121.644 102.88C121.465 114.952 114.847 125.421 105.103 131.062L100.504 118.766C105.46 115.14 108.72 109.309 108.818 102.69C108.981 91.6743 100.329 82.58 89.3875 82.1288Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0525 77.4333C65.7342 72.6866 69.8008 69.1624 74.5962 69.1624H86.8976C102.523 69.1624 115.19 81.8295 115.19 97.4552V125.722L58.2675 124.672L65.0525 77.4333Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 67,
    width: 56,
    height: 61
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3473 78.804C63.3473 73.4791 67.6641 69.1624 72.989 69.1624H86.8984C102.524 69.1624 115.191 81.8295 115.191 97.4552V125.748H63.3473V78.804Z",
    fill: "#DEFBFF",
    stroke: "#003792",
    strokeWidth: 2.84509
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 65.4664,
    y1: 158.703,
    x2: 150.931,
    y2: 106.678,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.2022,
    y1: 153.341,
    x2: 147.667,
    y2: 101.316,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.9381,
    y1: 147.978,
    x2: 144.402,
    y2: 95.9532,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55.6739,
    y1: 142.616,
    x2: 141.138,
    y2: 90.5907,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.4092,
    y1: 137.253,
    x2: 137.874,
    y2: 85.2282,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.1451,
    y1: 131.891,
    x2: 134.609,
    y2: 79.8658,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.8804,
    y1: 126.528,
    x2: 131.345,
    y2: 74.5033,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.6158,
    y1: 121.166,
    x2: 128.08,
    y2: 69.1408,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.3521,
    y1: 115.803,
    x2: 124.816,
    y2: 63.7783,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.0875,
    y1: 110.441,
    x2: 121.552,
    y2: 58.4159,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.8233,
    y1: 105.079,
    x2: 118.288,
    y2: 53.0534,
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29.5601,
    y1: 99.7153,
    x2: 115.024,
    y2: 47.6902,
    stroke: "#003792",
    strokeWidth: 2.84509
  })), /*#__PURE__*/React.createElement("rect", {
    x: 46.2765,
    y: 120.374,
    width: 86.3011,
    height: 23.7091,
    rx: 11.8545,
    fill: "white",
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7602 131.923C55.7685 128.265 56.4084 124.652 57.6603 120.058H70.8979C69.9366 124.724 69.4021 128.395 69.3755 132.069C69.3489 135.744 69.8302 139.415 70.8937 144.083H57.6608C56.3754 139.294 55.7518 135.582 55.7602 131.923Z",
    fill: "#003792",
    stroke: "#003792",
    strokeWidth: 0.316121
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.203 132.07C127.199 128.412 126.538 124.749 125.226 120.058H111.445C112.691 124.722 113.336 128.394 113.346 132.071C113.356 135.747 112.731 139.419 111.447 144.083H125.226C126.555 139.391 127.207 135.728 127.203 132.07Z",
    fill: "#003792",
    stroke: "#003792",
    strokeWidth: 0.316121
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.3138,
    y: 119.742,
    width: 18.0189,
    height: 24.3413,
    fill: "#003792",
    stroke: "#003792",
    strokeWidth: 0.316121
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1526 39.2784L65.9766 38.9923L66.0953 38.1282C67.6613 26.7306 77.4411 17.9507 89.2693 17.9507C102.189 17.9507 112.662 28.4241 112.662 41.3436C112.662 54.2632 102.189 64.7366 89.2693 64.7366C77.7696 64.7366 68.2053 56.4374 66.2444 45.5014L66.0905 44.6429L65.2556 44.3907C64.1499 44.0567 63.3473 43.0291 63.3473 41.8178C63.3473 40.6448 64.0998 39.6439 65.1526 39.2784Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.598,
    cy: 33.4409,
    r: 2.68732,
    fill: "#003792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6521 37.7083C99.1391 37.7083 99.5432 38.0764 99.5427 38.5634C99.5407 40.4851 99.0788 44.9791 94.8009 44.9791C90.523 44.9791 90.0611 40.4851 90.0591 38.5634C90.0586 38.0764 90.4627 37.7083 90.9497 37.7083H98.6521Z",
    fill: "#003792"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.7401,
    cy: 33.4409,
    r: 2.68732,
    fill: "#003792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7999 75.1783L81.8001 75.1792L81.803 75.192C81.8061 75.2062 81.8113 75.2301 81.8181 75.263C81.8318 75.3289 81.8519 75.431 81.8753 75.5647C81.9222 75.8323 81.9817 76.224 82.0283 76.7028C82.1223 77.6677 82.1602 78.9492 81.9568 80.2672C81.7529 81.5879 81.3174 82.8769 80.5186 83.9278C79.739 84.9536 78.5556 85.831 76.6934 86.271C71.8365 87.4185 67.2936 91.5404 64.4052 96.6591C61.5013 101.805 60.1085 108.237 61.8866 114.239C63.3342 119.126 66.2988 123.154 70.1131 125.957L70.7728 126.442L71.5234 126.115C72.332 125.762 73.7044 125.255 74.9617 125.164C75.5836 125.119 76.0727 125.185 76.4232 125.335C76.731 125.468 76.9845 125.683 77.1646 126.107C77.5224 126.95 77.4269 127.434 77.2551 127.801C77.0282 128.286 76.5971 128.727 75.9285 129.375C75.8945 129.408 75.8594 129.442 75.8233 129.477C75.1258 130.15 74.0628 131.175 73.8021 132.606C73.6112 133.653 73.6564 134.613 73.9406 135.486C74.2247 136.359 74.7203 137.061 75.3068 137.633C76.3913 138.691 77.8971 139.392 79.1372 139.97L79.247 140.021C80.3051 140.514 81.2043 140.938 81.9165 141.455C82.6021 141.952 82.9937 142.451 83.1558 143.039C83.2292 143.305 83.1834 143.416 83.1506 143.477C83.0984 143.574 82.9512 143.754 82.5689 143.96C81.7762 144.389 80.4273 144.693 78.6769 144.818C75.2228 145.063 70.9241 144.565 68.3216 143.822C66.8353 143.397 65.6467 142.867 64.7119 142.336L64.6745 142.315L64.6358 142.296C55.1181 137.628 47.5124 129.149 44.2652 118.187C38.209 97.7416 47.3684 76.7091 67.1801 70.0441C74.0832 67.9481 77.6276 69.4881 79.4592 71.1617C80.4217 72.0413 81.0103 73.0452 81.3585 73.8392C81.5316 74.234 81.6418 74.569 81.7071 74.7978C81.7397 74.9119 81.7609 74.9986 81.7731 75.0519C81.7791 75.0785 81.7829 75.0967 81.7847 75.1057C81.7851 75.1076 81.7854 75.1091 81.7856 75.1102C81.7858 75.1111 81.786 75.1117 81.786 75.112L81.786 75.1122L81.7913 75.1419L81.7995 75.1768L81.7997 75.1775L81.7999 75.1781L81.7999 75.1783Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 2.84509
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.441,
    cy: 22.7892,
    rx: 5.53212,
    ry: 3.79345,
    transform: "rotate(23.2182 101.441 22.7892)",
    fill: "#003792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.352 24.2167L106.125 25.6388L104.191 24.0466L105.596 22.3409L107.352 24.2167Z",
    fill: "#003792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8797 19.8415L97.8155 21.7508L99.513 19.9092L98.0833 18.4452L96.8797 19.8415Z",
    fill: "#003792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.003 23.2624C106.723 23.9162 106.048 24.4229 105.029 24.6251C104.014 24.8265 102.738 24.7004 101.461 24.1529C100.185 23.6054 99.214 22.7674 98.6604 21.8932C98.1045 21.0152 98.007 20.1774 98.2874 19.5236C98.5679 18.8698 99.2421 18.3631 100.261 18.1609C101.277 17.9595 102.553 18.0855 103.829 18.6331C105.106 19.1806 106.076 20.0186 106.63 20.8928C107.186 21.7708 107.283 22.6086 107.003 23.2624Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 1.58061
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 83.6855,
    cy: 23.1014,
    rx: 5.53212,
    ry: 3.79345,
    transform: "rotate(-13.3909 83.6855 23.1014)",
    fill: "#003792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2813 20.7227L89.1441 22.5962L86.6426 22.4712L86.7529 20.2643L89.2813 20.7227Z",
    fill: "#003792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2662 23.4555L80.1561 24.43L80.4205 21.9394L78.3998 21.6169L78.2662 23.4555Z",
    fill: "#003792"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4322 20.1646C88.597 20.8567 88.3579 21.6655 87.6603 22.4357C86.9656 23.2026 85.8659 23.8626 84.5148 24.1843C83.1638 24.5059 81.8847 24.4122 80.9189 24.0406C79.9491 23.6673 79.3712 23.053 79.2064 22.3609C79.0417 21.6689 79.2807 20.86 79.9784 20.0898C80.6731 19.3229 81.7728 18.6629 83.1238 18.3413C84.4749 18.0196 85.754 18.1133 86.7197 18.4849C87.6896 18.8582 88.2675 19.4725 88.4322 20.1646Z",
    fill: "white",
    stroke: "#003792",
    strokeWidth: 1.58061
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6816 24.5412C72.6174 27.0462 68.9772 29.8061 65.9741 38.9736",
    stroke: "#003792",
    strokeWidth: 1.58061
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.214 23.5289C90.7303 22.0772 93.119 21.7156 97.795 23.2301",
    stroke: "#003792",
    strokeWidth: 1.58061
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H176V257H0V0Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoingSwimming);
export default __webpack_public_path__ + "static/media/going-swimming.99c23036.svg";
export { ForwardRef as ReactComponent };